// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".big-icon[data-v-45d20ee6]{position:relative;top:-15px;border-radius:10px!important}[data-v-45d20ee6] .v-text-field.v-text-field--enclosed .v-text-field__details{padding-bottom:10px}", ""]);
// Exports
module.exports = exports;
